import config from '@/config';

/**
 * You can use this hack to mark any func/method params as mandatory
 *
 * @example
 * const foo = (bar = mandatory()) => {
 *   return bar;
 * }
 */
export const mandatory = (hint) => {
  throw new Error(`${hint} is required` || 'Missing parameter!');
};

/**
 * Return image path for correct platform
 * @param path
 * @returns {*}
 */
function getImagePath(path) {
  return config.imagesBucket[process.env.PLATFORM] + path;
}

/**
 * Format phone number with dots
 */
export const formatPhoneDots = (phone) => {
  if (phone) {
    let formatPhone = phone;

    if (formatPhone.startsWith('+1')) {
      formatPhone = phone.slice(2, phone.length);
    }

    return `${formatPhone.slice(0, 3)}.${formatPhone.slice(3, 6)}.${formatPhone.slice(6, 10)}`;
  }

  return '';
};

/**
 * Format distance
 */
const  formatDistance = (distance) =>  {
  if (distance !== null) {
    return `${distance} mi`;
  }

  return '';
};

/**
 * Returns kiosk secret key
 * @returns {string}
 */
const getKioskSecret = () => process.env.KIOSK_SECRET;

/**
 *  Menu items sorting function.
 *  @param {Object} products.
 * @return {any[]}
 */
export function menuItemsSorting(products) {
  return Object.entries(products)
    .map(([ key, product ]) => Object.assign({ key }, product))
    .filter(({ showInMenu }) => showInMenu)
    .sort((p1, p2) => p1.orderIndex - p2.orderIndex);
}

export default {
  mandatory,
  getImagePath,
  formatPhoneDots,
  formatDistance,
  getKioskSecret,
};



// WEBPACK FOOTER //
// ./src/lib/helpers.js